export const startLootboxAnimation = (
    lootboxContent,
    setVisibleItems,
    setHiddenIndices,
    onAnimationEnd
) => {
    const {lootSequence, openSequence} = lootboxContent;
    setVisibleItems(lootSequence);
    setHiddenIndices([]);

    let currentIndex = 0;
    let leftIndex = 0;
    let rightIndex = lootSequence.length - 1;
    let interval;

    const startInterval = () => {
        interval = setInterval(() => {
            if (currentIndex < openSequence.length) {
                const side = openSequence[currentIndex];
                let indexToHide;

                if (side === 'L') {
                    indexToHide = leftIndex;
                    leftIndex++;
                } else if (side === 'R') {
                    indexToHide = rightIndex;
                    rightIndex--;
                }

                // Update the state without side effects
                setHiddenIndices((prevIndices) => {
                    const newIndices = [...prevIndices];
                    if (indexToHide >= 0 && indexToHide < lootSequence.length) {
                        newIndices.push(indexToHide);
                    }
                    return newIndices;
                });

                currentIndex++;
            } else {
                clearInterval(interval);
                if (onAnimationEnd) {
                    onAnimationEnd();
                }
            }
        }, 500);
    };

    const timeout = setTimeout(startInterval, 200);

    return () => {
        clearTimeout(timeout);
        clearInterval(interval);
    };
};
